import React, { useState } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";
import InputField from "../../../../components/Common/InputField"; // Import InputField component
import { Box, Button, styled } from "@mui/material";

const VerifyCode = () => {
  // const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  // const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { email, organization_id } = location.state || {}; 

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !verificationCode) {
      // setError("Please fill in all fields.");
      return;
    }

    setLoading(true); // Start loading when the form is submitted

    try {
      console.log("Navigating with email:", email, "and code:", verificationCode);
      // Simulating an API call or form submission, you can add your verification logic here.
      // After the "API call" completes, you navigate to the reset-password page
      setTimeout(() => {
        navigate("/reset-password", { state: { email, organization_id ,verificationCode} });
        setLoading(false); // Stop loading once the action is completed
      }, 2000); // Simulating a 2-second API call delay
    } catch (error) {
      setLoading(false); // Stop loading if there is an error
      console.error(error);
      // setError("An error occurred while processing your request.");
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <FormMiddleBoxWrap>
          <RowWrap>
            <Col12Wrap>
              <Box sx={{ maxWidth: "400px", margin: "auto" }}>
                {/* <FormGroupWrap>
                <InputField
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    errorMessage={error}
                    register={()=>{}}
                  />
                </FormGroupWrap> */}
                <FormGroupWrap>
                  <InputField
                    type="text"
                    name="verificationCode"
                    placeholder="Verification Code"
                    value={verificationCode}
                    onChange={(e) => setVerificationCode(e.target.value)}
                    register={()=>{}}
                    errorMessage=""
                  />
                </FormGroupWrap>
                <FormGroupWrap>
                  <CustomBtn
                    type="submit"
                    variant="outlined"
                    disabled={loading}
                  >
                    {loading ? "Verifying..." : "Verify Code"}
                  </CustomBtn>
                </FormGroupWrap>
                <FormGroupWrap sx={{ marginBottom: "0", textAlign: 'center' }}>
                    <CustomLink to="/">Sign in</CustomLink>
                </FormGroupWrap>
              </Box>
            </Col12Wrap>
          </RowWrap>
        </FormMiddleBoxWrap>
      </form>
    
    </>
  );
};

export default VerifyCode;

const FormMiddleBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  borderRadius: "0px 0px 7px 7px",
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const FormGroupWrap = styled(Box)(() => ({
  marginBottom: "20px",
  position: "relative",
}));
const CustomBtn = styled(Button)(() => ({
  width: "100%",
  fontSize: "20px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  padding: "15px 20px",
  boxShadow: "none !important",
}));
const CustomLink = styled(Link)(() => ({
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#2C2C2E",
  textDecoration: "none",
  "&:hover": {
    color: "#1085AB",
  textDecoration: "underline",
  }
}));
